import { Component, OnInit } from '@angular/core';
import {GeneralMessages} from '../shared/services';

@Component({
  selector: 'app-test-modal',
  templateUrl: './test-modal.component.html',
  styleUrls: ['./test-modal.component.scss']
})
export class TestModalComponent {

  constructor(private messaging: GeneralMessages) { }
  testMethodClose() {
    console.log('lo habría cerrado');
  }
  testMethodOpen() {
    console.log('lo habría borrado');
  }
  testInfo() {
    this.messaging.info('Titulo informativo', 'Se ha grabado una oferta');
  }
  testWarning() {
    this.messaging.warning('Estas seguro?', 'Desea borrar esta oferta?', 'borrar', this.testMethodOpen, 'cancelar', this.testMethodClose);
  }
  testError() {
    this.messaging.error('error', 'se ha producido un error en el login');
  }
}



// WEBPACK FOOTER //
// ./src/app/test-modal/test-modal.component.ts